import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { HttpService } from 'modules/core/services/api/http.service';

export const serverTimeResolver: ResolveFn<Promise<{ status: true; data: number }>> = (route, state) => {
	const httpService = inject(HttpService);
	return httpService.getServerTime();
};
